(function() {
    'use strict';

    angular.module('ksef')
        .controller('KsefCompanyListController', KsefCompanyListController);

    KsefCompanyListController.$inject = [
        '$scope',
        '$state',
        'checkSearchSrvc',
        'filterQuerySrvc',
        'datatableDefaultPageSizeValueConst',
        'ksefCompanyDataSrvc',
        'ksefCompanyPermissionsConst'
    ];

    function KsefCompanyListController(
        $scope, $state, checkSearchSrvc, filterQuerySrvc, datatableDefaultPageSizeValueConst,
        ksefCompanyDataSrvc, ksefCompanyPermissionsConst
    ) {
        var self = this;

        self.loading = true;

        self.pageOpts = {
            count: 0,
            page: 1,
            pageSize: datatableDefaultPageSizeValueConst
        };

        self.companyRows = [];
        self.companyCols = [{
            title: 'Nazwa',
            value: 'name',
            type: 'text',
            searchable: true,
            orderable: true
        }, {
            title: 'NIP',
            value: 'nip',
            type: 'text',
            searchable: true,
            orderable: true
        },
        {
            title: 'Połączono z KSeF',
            value: 'is_connection_active',
            type: 'boolean',
            searchable: false,
            orderable: false
        }];

        self.modelPermissions = ksefCompanyPermissionsConst;
        self.searchQuery = {
            name: null,
            nip: null,
            ordering: null
        };

        self.onClick = onClick;
        self.onCreate = onCreate;
        self.onEdit = onEdit;

        self.pageChange = pageChange;
        self.onSearchQueryChange = onSearchQueryChange;

        activate();

        function activate() {
            self.pageOpts = filterQuerySrvc.initializePageOpts(self.pageOpts);
            self.searchQuery = filterQuerySrvc.initializeSearchQuery(self.searchQuery);
            filterQuerySrvc.setLocationParams();
            getCompanies();
        }

        function getCompanies(filterObj) {
            self.loading = true;

            if (!filterObj) {
                filterObj = {
                    page: self.pageOpts.page,
                    page_size: self.pageOpts.pageSize,
                    name: self.searchQuery.name,
                    nip: self.searchQuery.nip,
                    ordering: self.searchQuery.ordering
                };
            }
            return ksefCompanyDataSrvc.list(filterObj)
                .$promise
                .then(function (response) {
                    self.companyRows = response.results;
                    self.pageOpts.count = response.count;
                    return response;
                })
                .catch(function(response) {
                    if (response.status === 404 && filterObj.page !== 1) {
                        checkSearchSrvc.recall(filterObj, getCompanies);
                    }
                })
                .finally(function (response) {
                    self.loading = false;
                    return response;
                });
        }

        function onClick(row) {
            $state.go('layout.ksef-companies.detail',  { pk: row.pk });
        }

        function onCreate() {
            $state.go('layout.ksef-companies.create');
        }

        function onEdit(row) {
            $state.go('layout.ksef-companies.update', { pk: row.pk });
        }

        function pageChange() {
            filterQuerySrvc.updatePageOpts(self.pageOpts);
            filterQuerySrvc.setLocationParams();
            return getCompanies();
        }

        function onSearchQueryChange() {
            filterQuerySrvc.updateSearchQuery(self.searchQuery);
            filterQuerySrvc.setLocationParams();
            return getCompanies();
        }
    }
})();
